<template>
    <div>
        <img
            class="l-achievement-top"
            src="./images/back-top.png"
            width="100%"
            alt=""
        />
       
        <img
            class="l-achievement-bottom"
            src="./images/back-stage.png"
            width="100%"
            alt=""
        />
    </div>
</template>
<script>
export default {
    name: "l-achievement-cup",
    props: {
       
    },
    data() {
        return {
           
        };
    },
   
    created() {
      
    },
    methods: {
        
    },
};
</script>

<style scoped lang="stylus">
@import './index.styl';
</style>